import React, { useRef, useState } from "react";
import { BsPlayCircleFill, BsFillPauseCircleFill } from "react-icons/bs";

const VideoPlayer = ({ path, poster, autoPlay }) => {
  const [isPlaying, setIsPlaying] = useState(autoPlay);
  const [isHovered, setIsHovered] = useState(false);
  const videoRef = useRef(null);

  const handlePlayPauseVideo = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div
      className="relative w-full max-h-[200px] sm:max-h-[300px] md:max-h-[400px] lg:max-h-[545px]"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <video
        autoPlay={autoPlay}
        muted={autoPlay}
        loop={autoPlay}
        ref={videoRef}
        src={path}
        poster={poster}
        className="w-full object-cover"
      />

      {(isHovered || !isPlaying) && (
        <div className="absolute inset-0 flex items-center justify-center">
          {isPlaying ? (
            <BsFillPauseCircleFill
              className="w-16 h-16 text-white cursor-pointer"
              onClick={handlePlayPauseVideo}
            />
          ) : (
            <BsPlayCircleFill
              className="w-16 h-16 text-white cursor-pointer"
              onClick={handlePlayPauseVideo}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default VideoPlayer;
